import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './user-view/dashboard/dashboard.component';
import { AuthGuard } from './login/services/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: '',
    loadChildren : './login/login.module#LoginModule'
  },
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: './user-view/user-view.module#UserViewModule',
        // canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, {useHash: true}) ],
  exports: [ RouterModule ]
})
export class AppRoutesModule {}



// WEBPACK FOOTER //
// ./src/app/app.routes.ts